import { Language } from '@/models/general';

export type SeoMetaData = {
    language: Language;
    title: string;
    description: string;
    slug: string;
};

export const createSeoMetaData = (language: Language) => ({
    language,
    title: '',
    description: '',
    slug: '',
});

export const createSeoMetaDataForAllLanguages = () =>
    Object.values(Language).map(createSeoMetaData);

export const isValidSeoMetaData = (seoMetaData: SeoMetaData) => {
    const { title, description, slug } = seoMetaData;
    return title.length > 0 && description.length > 0 && slug.length > 0;
};
